/* eslint-disable react-native/no-unused-styles */
import { Box, Text } from 'native-base'
import { StyleSheet } from 'react-native'

import { useTranslation } from '~hooks'
type BoxType = {
  points: string
  code?: string
  isRedeemed?: boolean
  cornersType?: 'default' | 'bottom'
}
export const PointsBox = ({
  points,
  code,
  cornersType = 'default',
  isRedeemed = false,
}: BoxType) => {
  const { t } = useTranslation()

  return (
    <Box
      bg={isRedeemed ? 'offBlue' : 'actionBlue'}
      justifyContent="center"
      px="3"
      py="2"
      style={styles[cornersType]}
    >
      {/* TODO: Add redeemed option when delivered by BE */}
      <Text fontWeight="500" color={isRedeemed ? 'actionBlue' : 'white'} fontSize="sm">
        {isRedeemed
          ? code
            ? code.slice(0, 10) + '...'
            : `${t('common.coupon_redeemed').toUpperCase()}`
          : `${points} ${t('common.coins').toUpperCase()}`}
      </Text>
    </Box>
  )
}

const styles = StyleSheet.create({
  bottom: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  default: {
    borderBottomLeftRadius: 8,
    borderTopRightRadius: 8,
  },
})
